import React, { useState, useContext, useEffect} from 'react'
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../layout/Content'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import ReceiptFooterStyle from './css/ReceiptFooterStyle'
import InvoiceController from '../../invoice/invoice/InvoiceController'
import ReceiptsListController from '../receiptslist/ReceiptsListController'
import CustomerCreditAccountController from '../../customers_accounts/customer_credit_account/CustomerCreditAccountController'
import ReceiptItemController from '../receiptitem/ReceiptItemController'
import { appContext } from '../../../App'
import { receiptControllerContext } from './ReceiptController'
import { getCustomerAccountById, saveCustomer } from '../../customers_accounts/CustomersAccountsFunctions'
import { getReceiptById } from '../ReceiptFunctions'

function ReceiptFooter() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const receiptController = useContext(receiptControllerContext)
  const { saveReceipt, deleteReceipt } = receiptController
  const receipt = receiptController.receipt[0]
  const [nextOk, setNextOk] = useState((receipt._id) ? true : false)

  const showMessageBoxReceiptNotFound = () => {
    const onClick = async () => {
      setContent(<ReceiptsListController />)
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }
    ReactDOM.render (
      <ModalWindow id='mw-parent' height='20' width='25' header='Receipt Not Found' footer={null}>
        <div className='messagebox'>
          <div className='messagebox-content'>
            <div>Receipt no longer exist!</div>
          </div>
          <div className='button-container'>
            <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
          </div>
        </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickNext = (e) => {
    saveReceipt(app, receipt, true)
    .then( async (data) => {
      if (data) {
        // If it's a Customer Credit Account then
        if (receipt.receipt_for.item_name === 'Customer Credit Account') {
          //const customerAccount = await getCustomerAccountById(receipt.receipt_for.item_id.customer_account_id, app)
          const customerAccount = await getCustomerAccountById(app, receipt.receipt_for.item_id.customer_account_id)
          const credit_account = customerAccount.credit_accounts.find((ca) => (ca.credit_account_number === parseInt(receipt.receipt_for.item_id.credit_account_number)))
          credit_account.status = 'Unsettled'
          await saveCustomer(app, customerAccount)
        }
        // View the receipt
        setContent(<ReceiptItemController receipt={data}/>)
      } else showMessageBoxReceiptNotFound()
    })
  }

  const onClickDeleteReceipt = async (e) => {
    let rec = await getReceiptById(app, receipt._id)

    const showMessageBox = () => {
      const onClick = async (button) => {
        if (button === 'Yes') {
          // Check again fro existence
          rec = await getReceiptById(app, receipt._id)
          if (rec) {
            deleteReceipt(app, receipt)
            .then(res => { setContent(<ReceiptsListController />) })
          } else {
            // close current messagebox
            ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
            showMessageBoxReceiptNotFound()
            return // escpage closing messagebox immediately
          }
        }

        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          height='30'
          width='35'
          header="Delete Record"
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>This will delete the current receipt and restore back the document that is currently link to it.</div>
              <br></br>
              <div>Are you sure you want to continue?</div>
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    if (rec) showMessageBox()
    else showMessageBoxReceiptNotFound()
  }

  const onClickBack = async (e) => {
    if (receipt.receipt_for.item_name === 'Invoice') {
      setContent(<InvoiceController invoice={receipt.receipt_for.item} />)
    } else  {
      const customerAccountId = receipt.receipt_for.item._id
      const creditAccountNumber = receipt.receipt_for.item.credit_accounts[receipt.receipt_for.item.credit_accounts.length - 1].credit_account_number
      const customerCreditAccountControllerProps = {
        customerAccountId,
        creditAccountNumber
      }
      setContent(<CustomerCreditAccountController { ...customerCreditAccountControllerProps} />)
    }
  }

  useEffect(() => {
    if (receipt.payments) setNextOk((receipt.payments.length > 1))
  }, [receipt.payments])

  let show_delete_receipt_button = (app.client.signed_in === 'admin')
  ? true : (app.client.signed_in.user_access.receipts_delete_receipt)

  show_delete_receipt_button = show_delete_receipt_button && Boolean(receipt._id)

  return (
    <ContentFooter>
      <div className="footer-container">
        <div className='action-button-container'>
          <button className="pospro-action-btn"
            style={{display: (receipt._id) ? 'none' : 'block'}}
            onClick={onClickBack}
            id='back-to-receipt-for'
            type="button">
            <FontAwesomeIcon icon='angle-left'/> <span>{`Back to ${receipt.receipt_for.item_name}`}</span>
          </button>
          <button className="pospro-action-btn"
            style={{display: (show_delete_receipt_button) ? 'block' : 'none'}}
            onClick={onClickDeleteReceipt}
            id='delete-receipt'
            type="button">
            <FontAwesomeIcon icon='times'/> <span>Delete Receipt</span>
          </button>
          <button className={(!nextOk) ? 'pospro-action-btn disabled-button' : 'pospro-action-btn'}
            onClick={onClickNext}
            disabled={!nextOk}
            id='next-btn'
            type="button">
            <FontAwesomeIcon icon='angle-right'/> <span>Next</span>
          </button>
        </div>
      </div>
      <ReceiptFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(ReceiptFooter)